import type {GameId} from "./gameCatalog";

/**
 * Each game's canvas height, alone in its own module (kitecorp/transferify-ui#2872, #2874, #2876).
 *
 * The eager game slot (`./GameSlot.styles`) needs them to hold a game's height while its lazy chunk
 * loads. Importing them from an engine instead put the whole engine into the landing's eager bundle:
 * Rollup keeps a module whole, so a single constant is enough to drag the class along.
 */
export const BYTE_RUNNER_HEIGHT = 190;
/** Taller than Byte Runner's, as in the approved prototype (owner decision 2026-09-24). */
export const FILE_INVADERS_HEIGHT = 270;
/** Pack the Zip's board: the tallest canvas yet, as in the approved prototype (owner decision 2026-09-25). */
export const PACK_THE_ZIP_HEIGHT = 320;
/**
 * 2048's canvas: its title and score line, the square board (at most 300px, as in the approved
 * prototype's 340px frame) and the hint under it (kitecorp/transferify-ui#2873).
 */
export const GAME_2048_HEIGHT = 392;
/**
 * The touch button row under Pack the Zip's board: 44px buttons, 8px padding above and below, and a
 * 1px rule. `./packTheZip/PackTheZipGame.styles` sizes the row from it, and the slot's placeholder
 * adds it to the canvas, so the card does not jump when the chunk arrives.
 */
export const PACK_THE_ZIP_CONTROLS_HEIGHT = 61;
/**
 * The × every game frame carries in its top-right corner: its side and its inset from the corner.
 * `./GameFrame.styles` places it with these, and Pack the Zip's layout keeps its side panel clear of it.
 */
export const CLOSE_BUTTON_SIZE = 40;
export const CLOSE_BUTTON_INSET = 6;

/**
 * The height each game's slot holds, canvas plus anything under it inside the frame (Pack the Zip's touch
 * row). The slot's placeholder keeps it while the chunk loads, and the recipient page's phone strip grows
 * to it while the game is open (kitecorp/transferify-ui#2889).
 */
export const GAME_SLOT_HEIGHTS: Record<GameId, number> = {
	byte_runner: BYTE_RUNNER_HEIGHT,
	file_invaders: FILE_INVADERS_HEIGHT,
	pack_the_zip: PACK_THE_ZIP_HEIGHT + PACK_THE_ZIP_CONTROLS_HEIGHT,
	"2048": GAME_2048_HEIGHT,
};
